import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import "./PieChart.css"
import { Pie } from 'react-chartjs-2';
import { Progress, Space } from 'antd';
import { Chart as ChartJS, ArcElement, Legend } from 'chart.js';
ChartJS.register(ArcElement, Legend);

const PieChart = ({ doughnutData, displayCycle }) => {
    const [completePercentage, setCompletePercentage] = useState(0);
    const [spinner, setSpinner] = useState(true);
    const [name, setName] = useState('')
    useEffect(() => {
        if (doughnutData.length > 0 && displayCycle === 1) {
            setSpinner(true)
            let tempdata = 0;
            for (let i = 0; i < 8; i++) {
                tempdata = tempdata + parseFloat(doughnutData[i].percent);
            }
            const sampleData = parseFloat(tempdata / 8);
            const roundedNumber = sampleData.toFixed(0);
            setCompletePercentage(roundedNumber)
            setName('Regular Payroll')
            setSpinner(false)
        }
        else if (doughnutData.length > 0 && displayCycle === 2) {
            setSpinner(true)
            let tempdata = parseFloat(doughnutData[10].percent);
            console.log(tempdata)
            const sampleData = parseFloat(tempdata / 1);
            console.log(sampleData)
            const roundedNumber = sampleData.toFixed(0);
            console.log(roundedNumber)
            setCompletePercentage(roundedNumber)
            setName('Off Cycle Payroll')
            setSpinner(false)
        }
        else if (doughnutData.length > 0 && displayCycle === 3) {
            setSpinner(true)
            let tempdata = parseFloat(doughnutData[8].percent) + parseFloat(doughnutData[9].percent);
            const sampleData = parseFloat(tempdata / 2);
            const roundedNumber = sampleData.toFixed(0);
            setCompletePercentage(roundedNumber)
            setName('Expenses Management')
            setSpinner(false)
        }
    }, [doughnutData, displayCycle])
    return (<>
        <div className="piechart-wholediv">
            <div className="piechart">
                {spinner ? <div className="pie-spinner"><Spin size="large" /></div> :
                    <Progress type="circle"  percent={completePercentage} strokeColor={"rgba(0, 58, 140, 1)"}
                        strokeLinecap="round"
                        format={(percent) => (
                            <div>
                                <div className="percent-class" style={{ marginBottom: 4 }}>{name}</div>
                                <div className="percent-class">{percent}%</div>
                            </div>
                        )}
                        className="doughnut-class" />
                }
            </div>
        </div>
    </>);
}
export default PieChart;
